import { render, staticRenderFns } from "./VenueVerification.vue?vue&type=template&id=5b419bce"
import script from "./VenueVerification.vue?vue&type=script&lang=ts"
export * from "./VenueVerification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports